import React from 'react';

import {UnknownStructuredTable} from 'notebook/structured-tables/StructuredTableConstants';
import ToggleEditStructuredTableOutsideNotebook, {
  ToggleEditStructuredTableOutsideNotebookProps,
} from 'notebook/structured-tables/ToggleEditStructuredTableOutsideNotebook';
import useResizableProcessStructuredTable from 'processes/tables/useResizableProcessStructuredTable';

/**
 * A process task or output table whose columns can be resized in edit mode, with widths persisted per
 * user in localStorage.
 *
 * This wraps ToggleEditStructuredTableOutsideNotebook and owns the width persistence, since keying
 * widths by table kind is a process concern that does not belong in the generic table component. It
 * overlays stored widths onto the table and routes resizes into the store, forwarding every other edit
 * to the caller's update handler unchanged.
 */
export default function ResizableProcessStructuredTable<T extends UnknownStructuredTable>(
  props: ToggleEditStructuredTableOutsideNotebookProps<T>
): JSX.Element {
  const {structuredTable, updateHandler, revertHandler} = useResizableProcessStructuredTable({
    structuredTable: props.structuredTable,
    updateHandler: props.update,
    revertHandler: props.revert,
  });

  return (
    <ToggleEditStructuredTableOutsideNotebook
      {...props}
      structuredTable={structuredTable}
      update={updateHandler}
      revert={revertHandler ?? props.revert}
      enableColumnResizing={true}
    />
  );
}
